export default {
  'dashboard.monitor.trading-activity': 'Real-Time Trading Activity',
  'dashboard.monitor.total-transactions': 'Total transactions today',
  'dashboard.monitor.sales-target': 'Sales target completion rate',
  'dashboard.monitor.remaining-time': 'Remaining time of activity',
  'dashboard.monitor.total-transactions-per-second': 'Total transactions per second',
  'dashboard.monitor.activity-forecast': 'Activity forecast',
  'dashboard.monitor.efficiency': 'Efficiency',
  'dashboard.monitor.ratio': 'Ratio',
  'dashboard.monitor.proportion-per-category': 'Proportion Per Category',
  'dashboard.monitor.fast-food': 'Fast food',
  'dashboard.monitor.western-food': 'Western food',
  'dashboard.monitor.hot-pot': 'Hot pot',
  'dashboard.monitor.waiting-for-implementation': 'Waiting for implementation',
  'dashboard.monitor.popular-searches': 'Popular Searches',
  'dashboard.monitor.resource-surplus': 'Resource Surplus',
  'dashboard.monitor.fund-surplus': 'Fund Surplus',
};
